import { Download } from "@mui/icons-material";
import {
  Card,
  CustomButton,
  Description,
  ModalContainer,
  Title,
} from "./styles";

interface Props {
  open: boolean;
  onClose: () => void;
  handleDownload: () => void;
}

const SpreadsheetDownloadModal = ({ open, onClose, handleDownload }: Props) => {
  return (
    <ModalContainer open={open} onClose={onClose}>
      <Card>
        <Title variant="h6">Faça do download</Title>
        <Title variant="h6">da Planilha</Title>

        <Description variant="h6">
          Baixe e preencha a planilha com os dados dos animais.
        </Description>

        <Description variant="h6">
          {`Em seguida, utilize o botão "Importar Animais" para trazer os
                dados para o BovPilot`}
        </Description>

        <CustomButton startIcon={<Download />} onClick={handleDownload}>
          Baixar planilha
        </CustomButton>
      </Card>
    </ModalContainer>
  );
};

export default SpreadsheetDownloadModal;
